const ExtraBox = () => (
    <>
        <span className="icon">
            <i className="fas fa-gifts"></i>
        </span>
        <span>Extra</span>
    </>
);

const ReplacementBox = () => (
    <>
        <span className="icon">
            <i className="fas fa-people-carry"></i>
        </span>
        <span>Replacement</span>
    </>
);

const WinbackBox = () => (
    <>
        <span className="icon">
            <i className="far fa-life-ring"></i>
        </span>
        <span>Win Back</span>
    </>
);

const Divier = () => (
    <span className="icon">
        <i className="fas fa-ellipsis-v is-size-7"></i>
    </span>
);

const NewBoxType = ({ box }) => {
    const boxType = box.box_type;
    const typeMap = { 'extra_box': ExtraBox, 'replacement_box': ReplacementBox, 'win_back_box': WinbackBox }

    if (!boxType?.length) {
        return null;
    }

    const View = () => {
        const v = [];
        for (const [index, t] of boxType.entries()) {
            const Component = typeMap[t];
            v.push(<Component key={`type-${t}`} />);

            if (index + 1 !== boxType.length) {
                v.push(<Divier key={`divider-${index}`} />);
            }
        }

        return v;
    }

    return (
        <span className="icon-text">
            <View />
        </span>
    );
};

const LegacyBoxType = () => (
    <span className="icon-text">
        <ExtraBox />
    </span>
);

const BoxType = ({ box }) => {

    if (box.extra_box) {
        return (
            <LegacyBoxType />
        );
    }

    return (
        <NewBoxType box={box} />
    );
}

export { BoxType };
